export default __webpack_public_path__ + "static/media/information.88ffaba7.png";